import { z } from 'zod';
export const FILE_TYPES = [
    'manual_pdf', 'disk_d64', 'disk_tap', 'disk_adf', 'disk_dsk',
    'rom', 'firmware', 'schematic', 'other',
];
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
export const ALLOWED_MIME_TYPES = {
    manual_pdf: ['application/pdf'],
    disk_d64: ['application/octet-stream'],
    disk_tap: ['application/octet-stream'],
    disk_adf: ['application/octet-stream'],
    disk_dsk: ['application/octet-stream'],
    rom: ['application/octet-stream'],
    firmware: ['application/octet-stream'],
    schematic: ['application/pdf', 'image/png', 'image/jpeg'],
    other: ['application/octet-stream', 'application/pdf', 'image/png', 'image/jpeg'],
};
export const ALLOWED_EXTENSIONS = {
    manual_pdf: ['.pdf'],
    disk_d64: ['.d64'],
    disk_tap: ['.tap'],
    disk_adf: ['.adf'],
    disk_dsk: ['.dsk'],
    rom: ['.rom', '.bin'],
    firmware: ['.rom', '.bin', '.fw'],
    schematic: ['.pdf', '.png', '.jpg', '.jpeg'],
    other: ['.pdf', '.png', '.jpg', '.jpeg', '.txt', '.zip'],
};
export const createLibraryFileSchema = z.object({
    name: z.string().min(1).max(255),
    fileType: z.enum(FILE_TYPES),
    itemId: z.string().uuid().nullable().optional(),
    platform: z.string().max(100).optional().default(''),
    description: z.string().max(2000).optional().default(''),
});
export const libraryQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    fileType: z.enum(FILE_TYPES).optional(),
    platform: z.string().optional(),
    itemId: z.string().uuid().optional(),
    search: z.string().optional(),
});
export function validateFileUpload(fileType, mimeType, extension, size) {
    if (size > MAX_FILE_SIZE) {
        return { valid: false, error: `File size exceeds maximum of ${MAX_FILE_SIZE / 1024 / 1024}MB` };
    }
    const allowedMimes = ALLOWED_MIME_TYPES[fileType];
    if (allowedMimes && !allowedMimes.includes(mimeType)) {
        return { valid: false, error: `Invalid MIME type ${mimeType} for file type ${fileType}` };
    }
    const allowedExts = ALLOWED_EXTENSIONS[fileType];
    if (allowedExts && !allowedExts.includes(extension.toLowerCase())) {
        return { valid: false, error: `Invalid extension ${extension} for file type ${fileType}` };
    }
    return { valid: true };
}
//# sourceMappingURL=library.js.map